import { useContext } from 'react'

import {AuthContext} from "./AuthProvider";

const useKeycloak = () => {
    const context = useContext(AuthContext)

    if (!context.client) {
        throw new Error('keycloak client has not been assigned to KeycloakProvider')
    }

    const { client, isAuthenticated } = context
    const hasPermission = client?.hasResourceRole

    return {
        isAuthenticated,
        hasPermission,
        keycloak: client
    }
}

export { useKeycloak }
